import type {
    FC
} from "react";
import type ICommandEmptyProps from "./type";

const CommandEmpty: FC<ICommandEmptyProps> = () => {
    return null;
};
export default Object.assign(CommandEmpty, {
    commandPart: "empty"
});
